export const WIDGET_TYPES = {
  TIMESERIES: "Timeseries",
  TAG: "Tag",
  GAUGE: "Gauge",
  NORMALIZATION: "Normalization",
  PREDICTION: "Prediction",
  BAR_CHART: "BarChart",
  FREE_TEXT: "Text"
};
export const WIDGET_TYPE_GROUP_INTERVAL = {
  TIMESERIES: 1000,
  TAG: 70000000
};
